import parsePhoneNumber from 'libphonenumber-js/mobile';

export const formatPhoneNumber = (
	countryCode: string,
	mobileNumber: string | number
) => {
	if (countryCode && mobileNumber) {
		mobileNumber =
			typeof mobileNumber === 'number'
				? mobileNumber.toString()
				: mobileNumber;
		const phoneNumber = parsePhoneNumber(`${countryCode}${mobileNumber}`);
		return phoneNumber?.format('INTERNATIONAL');
	} else {
		return mobileNumber;
	}
};

export const formatMobileNumber = (
	countryCode: string,
	mobileNumber: string | number
) => {
	if (countryCode && mobileNumber) {
		mobileNumber =
			typeof mobileNumber === 'number'
				? mobileNumber.toString()
				: mobileNumber;
		const phoneNumber = parsePhoneNumber(`${countryCode}${mobileNumber}`);
		if (phoneNumber?.format('NATIONAL').charAt(0) === '0') {
			return phoneNumber?.format('NATIONAL').substring(1);
		} else {
			return phoneNumber?.format('NATIONAL');
		}
	} else {
		return mobileNumber;
	}
};
